import React from "react"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import FloatingActionButton from "material-ui/FloatingActionButton"
import ContentAdd from "material-ui/svg-icons/content/add"
import AddPayGroupDialog from "./AddPayGroupDialog"
import TableActionBar from "../../components/layout/TableActionBar"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import moment from "moment"
import * as api from "../../api"
import { IOTPolicy, IPayGroup, IPayType } from "../../models"
import { green500 } from "material-ui/styles/colors"
import AccountStore from "../../stores/AccountStore"
import AppStateStore from "../../stores/AppStateStore"
import * as timeHelper from "../../helpers/timeHelper"
import _ from "lodash"
interface IExtendPayGroup extends IPayGroup {
	deleteValidation: boolean
}
interface IProps {
	payGroups: IPayGroup[]
	payTypes: IPayType[]
	otPolicies: IOTPolicy[]
	accountId: string
	enablePayroll: boolean
	addPayGroup(payGroup: IPayGroup, cb: () => void): void
	updatePayGroup(payGroup: IPayGroup, cb: () => void): void
	deletePayGroup(payGroupId: string, cb: () => void): void
}
interface IState {
	searchedPayGroups: IPayGroup[]
	selectedIndex: number
	shouldRemovePayGroup: IExtendPayGroup
	searchText: string
	openAddPayGroupDialog: boolean
	editablePayGroup: IPayGroup
	selectedPayGroup: IPayGroup
	showTableActionBar: boolean
	canChangePaygroupCalendarSettings?: boolean
}
const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
const styles = {
	columnValue: {
		textAlign: "center",
		cursor: "pointer",
		whitespace: "normal",
		paddingLeft: 5,
		paddingRight: 5
	},
	propertyColumnValue: {
		textAlign: "center",
		cursor: "pointer",
		whitespace: "normal",
		paddingLeft: 5,
		paddingRight: 5
	},
	columnWideValue: {
		textAlign: "center",
		cursor: "pointer",
		whitespace: "normal",
		paddingLeft: 5,
		paddingRight: 5
	},
	noPayGroup: { textAlign: "center", fontSize: 25, paddingTop: 50, fontWeight: "bold", paddingLeft: 5, paddingRight: 5 }
}

export default class PayGroups extends React.Component<IProps, IState>  {
	private editablePayGroup: IPayGroup
	constructor(props) {
		super(props)
		this.state = {
			searchedPayGroups: [],
			selectedIndex: -1,
			shouldRemovePayGroup: null,
			searchText: "",
			openAddPayGroupDialog: false,
			editablePayGroup: null,
			selectedPayGroup: null,
			showTableActionBar: true,
		}
		autobind(this)
	}

	componentDidMount() {
		this.setState({
			searchedPayGroups: this.props.payGroups,
			selectedIndex: -1,
			shouldRemovePayGroup: null
		})
	}

	componentWillReceiveProps(nextProps) {
		!_.isEqual(this.props.payGroups, nextProps.payGroups) &&
			this.setState({
				searchedPayGroups: nextProps.payGroups,
				selectedIndex: -1,
				shouldRemovePayGroup: null
			})
	}

	onTableCellClick(rowNumber, columnId) {
		if (columnId === -1) {
			let { selectedIndex } = this.state
			if (selectedIndex === rowNumber) {
				selectedIndex = -1
			} else {
				selectedIndex = rowNumber
			}

			this.setState(
				{
					selectedIndex
				},
				() => {
					if (this.state.selectedIndex === -1) {
						this.setState({
							shouldRemovePayGroup: null
						})
					} else {
						const shouldRemovePayGroup = this.state.searchedPayGroups[selectedIndex] as IExtendPayGroup
						const { accountId } = this.props
						api.deleteValidationPayGroup(accountId, shouldRemovePayGroup.Id)
							.then((response) => {
								shouldRemovePayGroup.deleteValidation = response.data
								this.setState({
									shouldRemovePayGroup
								})
							})
							.catch((err) => {
								shouldRemovePayGroup.deleteValidation = false
								this.setState({
									shouldRemovePayGroup
								})
							})
					}
				}
			)
		} else {
			api.checkCanChangePaygroupCalendarSettings(this.props.accountId, this.state.searchedPayGroups[rowNumber].Id).then((res) => {
				this.editablePayGroup = this.state.searchedPayGroups[rowNumber]
				this.setState({ canChangePaygroupCalendarSettings: res.data })
				this.openEditPayGroupDialog()
			})
		}
	}

	openEditPayGroupDialog() {
		this.setState({
			editablePayGroup: this.editablePayGroup,
			openAddPayGroupDialog: true,
			selectedIndex: -1,
			shouldRemovePayGroup: null
		})
	}

	openAddPayGroupDialog() {
		this.setState({
			openAddPayGroupDialog: true
		})
	}

	closeAddPayGroupDialog() {
		this.setState({
			openAddPayGroupDialog: false,
			editablePayGroup: null
		})
	}

	handlerPayGroupSave(add, payGroup) {
		this.reloadTableActionBar()
		this.closeAddPayGroupDialog()
		AppStateStore.setProgressSnackbarContent("loading")
		add ?
			this.props.addPayGroup(payGroup, () => AppStateStore.setProgressSnackbarContent(strings.Pay_Group_added_successfully)) :
			this.props.updatePayGroup(payGroup, () => AppStateStore.setProgressSnackbarContent(strings.Pay_Group_updated_successfully))
	}

	onSearch(searchText) {
		const { payGroups } = this.props
		const searchedPayGroups = payGroups.slice().filter((payGroup) => {
			return payGroup.Name.toLowerCase().indexOf(searchText.toLowerCase()) > -1
		})

		this.setState({
			searchedPayGroups,
			selectedIndex: -1,
			shouldRemovePayGroup: null
		})
	}

	reloadTableActionBar() {
		this.setState({ showTableActionBar: false }, () =>
			this.setState({ showTableActionBar: true })
		)
	}

	getPayCalendarType(payCalendarType) {
		switch (payCalendarType) {
			case 0:
				return strings.Weekly
			case 1:
				return strings.Bi_Weekly
			case 2:
				return strings.Monthly
			case 3:
				return strings.Semi_Monthly
		}
	}

	getPayCalendarProperty(paySettings) {
		switch (paySettings.PayCalendarType) {
			case 0:
				return ""
			case 1:
				return "StartDate:  " + moment(timeHelper.keepConvertUTCToLocal(paySettings.PayCalendarStartDate)).format("dddd  MMMM DD, YYYY")
			case 2:
				return "PayDay:  " + paySettings.PayCalendarMonthlyPayDay1
			case 3:
				return "PayDay1:  " + paySettings.PayCalendarMonthlyPayDay1 + "  ----   PayDay2:  " + paySettings.PayCalendarMonthlyPayDay2
		}
	}

	render() {
		const { payGroups } = this.props
		if (payGroups.length === 0) {
			return (
				<div style={{ textAlign: "center", fontSize: 25, paddingTop: 50, fontWeight: "bold" }}>
					<span>{strings.There_is_no_pay_group}</span>
				</div>
			)
		}

		const { payTypes, enablePayroll } = this.props
		const { searchText, openAddPayGroupDialog, editablePayGroup, searchedPayGroups, selectedIndex, showTableActionBar } = this.state

		return (
			<div>
				<FloatingActionButton data-intercom-target={"menu-AccountSettings-PayConfiguration-PayGroupTab-Btn-Add"} className="fixed-add" style={{ top: -28, right: 20 }} secondary={true} onTouchTap={this.openAddPayGroupDialog}>
					<ContentAdd />
				</FloatingActionButton>
				<div style={{ paddingTop: 30 }}>
					{showTableActionBar &&
						<TableActionBar
							onSearch={this.onSearch.bind(this)}
							searchText={searchText}
							rowSelectionCount={selectedIndex === -1 ? 0 : 1}
							singleSelectedMessage={strings.Pay_Group_Selected}
							title={strings.Pay_Groups}
							titleStyle={{ fontSize: 16 }}
							bodyStyle={{ padding: 20, fontWeight: 500 }}
							onDeleteClick={() =>
								this.state.shouldRemovePayGroup.deleteValidation ?
									AppStateStore.setConfirmDialogContent({
										title: strings.Delete_Pay_Group,
										content: strings.Are_you_sure_delete_pay_group,
										confirm: () => {
											AppStateStore.setProgressSnackbarContent("loading")
											this.props.deletePayGroup(this.state.shouldRemovePayGroup.Id, () => AppStateStore.setProgressSnackbarContent(strings.Pay_Group_removed_successfully))
											this.reloadTableActionBar()
										}
									}) :
									AppStateStore.setProgressSnackbarContent(strings.You_cant_delete_pay_group)
							}
						/>
					}
					<div style={{ maxHeight: 250, overflowY: "auto" }}>
						<Table onCellClick={this.onTableCellClick}>
							<TableHeader>
								<TableRow className="ShortSelectBoxTableHeader">
									<TableHeaderColumn style={styles.columnValue}>{strings.Pay_Group_Name}</TableHeaderColumn>
									<TableHeaderColumn style={{ ...styles.columnWideValue, width: 160 }}>{strings.Max_PunchSet_Length_hours}</TableHeaderColumn>
									<TableHeaderColumn style={styles.columnValue}>{strings.Pay_Period_Start_Day}</TableHeaderColumn>
									{AccountStore.getPunchSplitEnabled() &&
										<TableHeaderColumn style={{ ...styles.columnValue, width: 180 }}>{strings.Split_Punches_by_Day_Boundary}</TableHeaderColumn>
									}
									<TableHeaderColumn style={styles.columnValue}>{strings.Workday_Start_Time}</TableHeaderColumn>
									{enablePayroll && [
										<TableHeaderColumn style={styles.columnValue} key="PayCalendarType">
											{strings.Pay_Calendar_Type}
										</TableHeaderColumn>,
										<TableHeaderColumn style={styles.propertyColumnValue} key="PayCalendarProperty">
											{strings.Pay_Calendar_Property}
										</TableHeaderColumn>
									]}
								</TableRow>
							</TableHeader>
							<TableBody deselectOnClickaway={false}>
								{searchedPayGroups.map((payGroup, key) =>
									<TableRow
										key={key}
										data-intercom-target={key === 0 && "menu-AccountSettings-PayConfiguration-PayGroupTab-openItemDetails"}
										selected={selectedIndex === key}
										className="ShortSelectBoxTableRow"
									>
										<TableRowColumn style={styles.columnValue}>{payGroup.Name}</TableRowColumn>
										<TableRowColumn style={{ ...styles.columnWideValue, width: 160 }}>{payGroup.PaySettings.MaximumPunchSetLength}</TableRowColumn>
										<TableRowColumn style={styles.columnValue}>{daysOfWeek[payGroup.PaySettings.PayPeriodStartDay]}</TableRowColumn>
										{AccountStore.getPunchSplitEnabled() &&
											<TableRowColumn style={{ ...styles.columnValue, width: 180 }}>
												{payGroup.PaySettings.SplitPunchAtDayStart && <i style={{ fontSize: 22, color: green500 }} className="fa fa-check" />}
											</TableRowColumn>
										}
										<TableRowColumn style={styles.columnValue}>
											{moment().hour(payGroup.PaySettings.PayPeriodDayStartTime24Hour).minute(0).format("hh:mma")}
										</TableRowColumn>
										{enablePayroll && [
											<TableRowColumn style={styles.columnValue} key="PayCalendarType">
												{this.getPayCalendarType(payGroup.PaySettings.PayCalendarType)}
											</TableRowColumn>,
											<TableRowColumn style={styles.propertyColumnValue} key="PayCalendarProperty">
												{this.getPayCalendarProperty(payGroup.PaySettings)}
											</TableRowColumn>
										]}
									</TableRow>
								)}
							</TableBody>
						</Table>
					</div>
				</div>
				{openAddPayGroupDialog &&
					<AddPayGroupDialog
						open={openAddPayGroupDialog}
						payTypes={payTypes}
						payGroups={payGroups}
						daysOfWeek={daysOfWeek}
						onRequestClose={this.closeAddPayGroupDialog}
						editablePayGroup={editablePayGroup}
						handlerPayGroupSave={this.handlerPayGroupSave}
						enablePayroll={enablePayroll}
						canChangePaygroupCalendarSettings={this.state.canChangePaygroupCalendarSettings}
						otPolicies={this.props.otPolicies}
					/>
				}
			</div>
		)
	}
}
